"use client";

import HeaderBackground from "@/components/ui/header-background";

const ReturnInfoHeader = () => {
  return <HeaderBackground type="black" />;
};

export default ReturnInfoHeader;
